import * as React from "react";
import {ReactUtils} from "../../utils/ReactUtils";
import type {Button} from "../../widgets/button/Button";
import {SVGIcon} from "../../widgets/button/SVGIcon";

export interface ISettingOptionProps {
	readonly label: string;
	readonly isGroup: boolean;
	readonly children?: React.ReactElement<Button> | React.ReactElement<Button>[];
	readonly selected: boolean;
	readonly onClick: () => void;
	readonly isParentOpened?: boolean;
}

export class SettingOption extends React.PureComponent<ISettingOptionProps> {
	private onClick = (event: React.MouseEvent) => {
		event.stopPropagation();
		this.props.onClick();
	};

	public override render() {
		const {selected, label, isParentOpened} = this.props;
		const children = React.Children.toArray(this.props.children) || [];
		const isGroup = this.props.isGroup;

		return (
			<div
				onClick={this.onClick}
				className={ReactUtils.cls("SettingOption", {
					selected,
					group: isGroup,
				})}
				data-cy={`setting-option-${label.toLowerCase()}`}
			>
				<span className="label">
					{label}
					{isGroup && (
						<>
							{isParentOpened ? (
								<span className="icon down" />
							) : (
								<SVGIcon
									icon="right"
									classNames="icon right"
								/>
							)}
						</>
					)}
				</span>
				{children}
			</div>
		);
	}
}
